import { Component, Injector } from '@angular/core';
import {
  StockDocTransferDto,
  StockDocTransferListDto,
  StockDocTransferService,
} from '@digiwall/goliath-documents/proxy';
import {
  StockDocListComponent,
  StockDocListComponentImports,
  StockDocListComponentProviders,
} from '../../stock-doc-list.component';
import { LocalizationService, SubscriptionService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { Router, ActivatedRoute } from '@angular/router';
import { DwGridDataSourceService } from '@digiwall/ag-grid';

@Component({
  selector: 'document-stock-transfer-list',
  templateUrl: './stock-doc-transfer-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: StockDocListComponentProviders,
  imports: StockDocListComponentImports,
})
export class StockDocTransferListComponent extends StockDocListComponent<
  StockDocTransferListDto,
  StockDocTransferDto,
  StockDocTransferService
> {
  constructor(
    docService: StockDocTransferService,
    router: Router,
    route: ActivatedRoute,
    confirmation: ConfirmationService,
    localizationService: LocalizationService,
    injector: Injector,
    subscriptionService: SubscriptionService,
    datasource: DwGridDataSourceService,
  ) {
    super(
      docService,
      router,
      route,
      confirmation,
      localizationService,
      injector,
      subscriptionService,
      datasource,
    );
  }
}
